import { prefix } from "../../design-tokens/meta";

export const componentName = "Text Input";

export const componentClasses = Object.freeze({
    size: {
        lg: "",
        sm: `${prefix}input-text__container--sm`,
    },
    icon: {
        start: `${prefix}input-text__icon--start`,
        end: `${prefix}input-text__icon--end`,
    },
    container: `${prefix}input-text__container`,
    wrapper: `${prefix}input-text__wrapper`,
    control: `${prefix}input-text`,
    hasIcon: `${prefix}has__icon--start`,
    helperText: `${prefix}input-text__helper`,
    errorText: `${prefix}invalid-feedback`,
    withButton: `${prefix}input-text__wrapper--button`,
});
